module.exports = __webpack_public_path__ + "img/1.41ce4a14.jpg";